import { createSceneReducer } from 'reducers/reducers-util';
import surveysDataReducer from 'components/admin/surveys/store/reducers.data';
import surveysUiReducer from 'components/admin/surveys/store/reducers.ui';

export default createSceneReducer(surveysDataReducer, surveysUiReducer);
